import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "hint" }
const _hoisted_3 = { class: "link" }
const _hoisted_4 = { class: "hint" }
const _hoisted_5 = { class: "link" }

import VPAutoLink from '@theme/VPAutoLink.vue'
import { useNavigate } from '@theme/useNavigate'
import { useRelatedLinks } from '@theme/useRelatedLinks'
import { useThemeLocaleData } from '@theme/useThemeData'
import { useEventListener } from '@vueuse/core'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPPageNav',
  setup(__props) {

const themeLocale = useThemeLocaleData()
const navigate = useNavigate()

const { prevLink, nextLink } = useRelatedLinks()

const navbarLabel = computed(
  () => themeLocale.value.pageNavbarLabel ?? 'page navigation',
)

useEventListener('keydown', (event): void => {
  if (event.altKey) {
    if (event.key === 'ArrowRight') {
      if (nextLink.value) {
        navigate(nextLink.value.link)
        event.preventDefault()
      }
    } else if (event.key === 'ArrowLeft') {
      if (prevLink.value) {
        navigate(prevLink.value.link)
        event.preventDefault()
      }
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_unref(prevLink) || _unref(nextLink))
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: "vp-page-nav",
        "aria-label": navbarLabel.value
      }, [
        (_unref(prevLink))
          ? (_openBlock(), _createBlock(VPAutoLink, {
              key: 0,
              class: "prev",
              config: _unref(prevLink)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "arrow left" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(themeLocale).prev ?? 'Prev'), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(_unref(prevLink).text), 1)
                ])
              ]),
              _: 1
            }, 8, ["config"]))
          : _createCommentVNode("", true),
        (_unref(nextLink))
          ? (_openBlock(), _createBlock(VPAutoLink, {
              key: 1,
              class: "next",
              config: _unref(nextLink)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_unref(themeLocale).next ?? 'Next') + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "arrow right" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_unref(nextLink).text), 1)
                ])
              ]),
              _: 1
            }, 8, ["config"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})